module.exports = __webpack_public_path__ + "static/img/Silver1.674147b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/apex/Silver1.svg
// module id = qAO5
// module chunks = 35